module.exports = __webpack_public_path__ + "img/noun-global-insurance-4831257.db197cd1.svg";